import React, { useState, useEffect } from 'react'
import { BazaarVoice, PublishedComponent } from '@pmi/pmi-iqos-shared-react'

const BazaarVoiceReviewComponent = ({
  type,
  productId,
  noReviewsLink = false
}) => {
  const [bazaarVoiceProductId, setBazaarVoiceProductId] = useState('')
  const [showType, setShowType] = useState('')
  const [hasListeners, setHasListeners] = useState(false)

  const handleCurrentBazaarVoiceProductId = e => {
    setBazaarVoiceProductId(e.detail)
  }

  useEffect(() => {
    if (typeof type !== 'undefined' && type.length !== 0) {
      setShowType(type)
    }
    // If productId is set since the beginning, it is hard fixed
    if (typeof productId !== 'undefined' && productId.length !== 0) {
      setBazaarVoiceProductId(productId)
    } else {
      // If it comes empty from the beginning, events can be triggered to update it
      window.addEventListener(
        'bazaarVoiceProductIdChanged',
        handleCurrentBazaarVoiceProductId
      )
      window.dispatchEvent(new window.CustomEvent('bazaarVoiceReviewInit'))
      setHasListeners(true)
    }

    return () => {
      if (hasListeners) {
        window.removeEventListener(
          'bazaarVoiceProductIdChanged',
          handleCurrentBazaarVoiceProductId
        )
      }
    }
  }, [])

  return (
    <>
      <BazaarVoice.OverrideStyle noReviewsLink={noReviewsLink} />
      {bazaarVoiceProductId && (
        <BazaarVoice
          type={showType}
          productId={bazaarVoiceProductId}
          data-testing-prefix="ProductDetail"
        />
      )}
    </>
  )
}

const BazaarVoiceReview = props => {
  return (
    <PublishedComponent
      innerComponent={BazaarVoiceReviewComponent}
      {...props}
    />
  )
}

BazaarVoiceReview.getInitialProps = async req => {
  return PublishedComponent.getGlobalInitialProps({
    context: req && req.query && req.query.context,
    componentName: 'BazaarVoiceReview',
    getSpecificInitialProps: () => {
      return {
        type: req.query.type,
        productId: req.query.productId,
        noReviewsLink: req.query.noReviewsLink === 'true'
      }
    }
  })
}

export default BazaarVoiceReview
